<template>
  <div>
    <wc-page-title title='Dashboard'></wc-page-title>
    <v-container>
      <v-row>
        <v-col cols='12'>
          <wc-data-box
            title='Staff List'
            :titleIcon='staffingData.icon'
            :titleIconColor='staffingData.color'
            :loading='isLoading'
            showAdd
            @add='showDialog = true'
            showSearch
            v-model='search'
          >
            <template v-slot:toolbarButtons>
              <wc-show-archived-button
                v-model='showArchived'
                showArchivedText='Show inactive staff'
                hideArchivedText='Hide inactive staff'
                @toggleShowArchived='toggleShowArchived'
              ></wc-show-archived-button>
            </template>
            <v-data-table
              dense
              :search='search'
              :headers='headers'
              :items='filteredStaff'
              :items-per-page='-1'
              @click:row='openProfile'
            >
              <template v-slot:item.name_display='{ item }'>
                {{ item.name_display }}
                <v-tooltip right v-if='item.high_season_help'>
                  <template v-slot:activator='{ on }'>
                    <v-icon v-on='on' :color='hsh.iconColor'>{{ hsh.icon }}</v-icon>
                  </template>
                  <span>{{ hsh.title }}/Contractor</span>
                </v-tooltip>
                <wc-archived
                  msg='Inactive'
                  v-if='!item.is_active'
                ></wc-archived>
              </template>
            </v-data-table>
          </wc-data-box>
        </v-col>
      </v-row>

      <add-user
        :showDialog='showDialog'
        @cancel='showDialog = false'
        @save='addUser'
      ></add-user>
    </v-container>
  </div>
</template>

<script>
import staffingAPI from '../../api/staffing'
import AddUser from './AddUser'
import _ from 'lodash'
// import moment from 'moment'

export default {
  name: 'staffing-dashboard',
  data: () => ({
    isLoading: true,
    showArchived: false,
    showDialog: false,
    staff: [],
    search: '',
    headers: [
      { text: 'Name', value: 'name_display' },
      { text: 'Username', value: 'username' }
    ]
  }),
  computed: {
    staffingData () {
      return this.$store.state.icons.modules.staffing
    },
    filteredStaff () {
      return this.showArchived ? _.orderBy(this.staff, 'name_display') : _.orderBy(this.staff.filter(s => s.is_active === true), 'name_display')
    },
    hsh () {
      // high season help
      return this.$store.state.icons.highSeasonHelp
    }
  },
  mounted () {
    this.getData()
  },
  methods: {
    async getData () {
      this.isLoading = true
      this.staff = await staffingAPI.getProfiles()
      this.isLoading = false
    },
    toggleShowArchived () {
      this.showArchived = !this.showArchived
    },
    openProfile (row) {
      this.$router.push({ name: 'ProfileOverview', params: { id: row.id } })
    },
    openAdd () {
      this.$router.push({ name: 'AddUser' })
    },
    addUser (user) {
      this.staff.push(user)
      this.showDialog = false
    }
  },
  components: {
    'add-user': AddUser
  }
}
</script>
